import { render, staticRenderFns } from "./ReadNFCBarcode.vue?vue&type=template&id=47f668c1&scoped=true"
import script from "./ReadNFCBarcode.vue?vue&type=script&lang=js"
export * from "./ReadNFCBarcode.vue?vue&type=script&lang=js"
import style0 from "./ReadNFCBarcode.vue?vue&type=style&index=0&id=47f668c1&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f668c1",
  null
  
)

export default component.exports